import { useState } from "react";
import { Link } from "react-router-dom";
import { api, apiErrorMessage } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { SEO } from "@/components/SEO";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(apiErrorMessage(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-6" data-testid="forgot-password-page">
      <SEO title="Reset Your A8A Password" description="Request a password reset link for your A8A account." noindex />
      <div className="w-full max-w-md space-y-5 border border-border p-8 bg-card">
        <h1 className="font-heading text-2xl font-medium text-foreground">Reset your password</h1>
        {sent ? (
          <p className="text-sm text-foreground leading-relaxed" data-testid="forgot-password-sent-message">
            If that email exists, we've sent a password reset link to it. The link expires in 30 minutes.
          </p>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-5">
            <p className="text-sm text-muted-foreground">Enter your account email and we'll send you a reset link.</p>
            <div>
              <Label htmlFor="email">Email</Label>
              <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-password-email-input" />
            </div>
            {error && <p className="text-sm text-destructive" data-testid="forgot-password-error-message">{error}</p>}
            <Button type="submit" className="w-full h-11" disabled={loading} data-testid="forgot-password-submit-button">
              {loading ? "Sending…" : "Send Reset Link"}
            </Button>
          </form>
        )}
        <p className="text-sm text-muted-foreground text-center">
          <Link to="/login" className="text-accent underline" data-testid="back-to-login-link">Back to login</Link>
        </p>
      </div>
    </div>
  );
}
